import { FC } from "react";
import { OrganizationRole } from "~/api/model";
import { useGetOrganization } from "~/api/organizations/organizations";
import { useOrganizationParams } from "~/helpers";

type DisplayForProps = {
  roles: OrganizationRole[];
  children: React.ReactNode;
};

export const DisplayFor: FC<DisplayForProps> = ({ roles, children }) => {
  const { organizationId } = useOrganizationParams();
  const { data: organization } = useGetOrganization(organizationId, {
    query: { enabled: Boolean(organizationId) },
  });

  if (!organizationId) return null;
  if (!organization) return null;
  if (!roles.includes(organization.role)) return null;

  return <>{children}</>;
};
